module.exports = __webpack_public_path__ + "static/1-bd9725bb2e563d29c219f00caf4e0490.jpg";